class FAQAccordion {
    constructor() {
        this.initializeAccordions();
    }

    initializeAccordions() {
        const faqButtons = document.querySelectorAll('.faq-btn');

        if (faqButtons.length === 0) {
            return;
        }

        faqButtons.forEach((button) => {
            button.addEventListener('click', this.handleClick.bind(this));
        });
    }

    handleClick(event) {
        const button = event.currentTarget;
        const faqItem = button.closest('.faq-item');

        if (!faqItem) {
            return;
        }

        const answer = faqItem.querySelector('.faq-answer');
        const icon = button.querySelector('.faq-icon');
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
            this.closeItem(button, answer, icon);
        } else {
            this.openItem(button, answer, icon);
        }
    }

    openItem(button, answer, icon) {
        button.setAttribute('aria-expanded', 'true');

        if (icon) {
            icon.textContent = '–';
        }

        if (answer) {
            const innerContent = answer.querySelector('.faq-answer-inner');
            const contentHeight = innerContent ? innerContent.scrollHeight : 0;

            answer.style.maxHeight = `${contentHeight}px`;
            answer.style.paddingTop = '1rem';
            answer.style.paddingBottom = '1.5rem';
        }
    }

    closeItem(button, answer, icon) {
        button.setAttribute('aria-expanded', 'false');

        if (icon) {
            icon.textContent = '+';
        }

        if (answer) {
            answer.style.maxHeight = '0';
            answer.style.paddingTop = '0';
            answer.style.paddingBottom = '0';
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new FAQAccordion();
    });
} else {
    new FAQAccordion();
}
